import { useSiteContent } from "@/hooks/useSiteContent";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Clock, Star } from "lucide-react";
import { optimizedImage } from "@/lib/img";

export function Hero() {
  const { content } = useSiteContent();
  return (
    <section id="home" className="relative overflow-hidden bg-gradient-subtle pt-20 pb-16 md:pt-28 md:pb-24">
      <div className="absolute inset-0 -z-10 opacity-30">
        <div className="absolute top-20 -left-20 h-72 w-72 rounded-full bg-accent/40 blur-3xl" />
        <div className="absolute bottom-0 right-0 h-96 w-96 rounded-full bg-primary/30 blur-3xl" />
      </div>
      <div className="container grid gap-10 md:grid-cols-2 md:items-center">
        <div className="animate-fade-up">
          <div className="inline-flex items-center gap-2 rounded-full bg-accent-soft px-4 py-1.5 text-sm font-semibold text-primary">
            <Star className="h-4 w-4 fill-accent text-accent" />
            {content.brand_tagline}
          </div>
          <h1 className="mt-5 text-4xl leading-tight text-balance text-foreground md:text-6xl">
            {content.hero_title}
          </h1>
          <p className="mt-5 max-w-xl text-lg text-muted-foreground">
            {content.hero_subtitle}
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Button size="lg" asChild className="bg-gradient-primary shadow-elegant hover:opacity-95 transition-smooth">
              <a href="#book">{content.hero_cta}</a>
            </Button>
            <Button size="lg" variant="outline" asChild>
              <a href={`tel:${content.shop_phone}`}>Call {content.shop_phone}</a>
            </Button>
          </div>
          <div className="mt-10 flex flex-wrap gap-6 text-sm">
            <div className="flex items-center gap-2"><Clock className="h-5 w-5 text-accent" /><span className="font-medium">{content.hero_badge_1}</span></div>
            <div className="flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-accent" /><span className="font-medium">{content.hero_badge_2}</span></div>
            <div className="flex items-center gap-2"><Star className="h-5 w-5 text-accent" /><span className="font-medium">{content.hero_badge_3}</span></div>
          </div>
        </div>
        <div className="relative animate-fade-up">
          <div className="absolute inset-0 -z-10 translate-x-6 translate-y-6 rounded-3xl bg-gradient-accent opacity-30 blur-2xl" />
          {content.hero_image_url && (
            <img
              src={optimizedImage(content.hero_image_url, 640, 70)}
              srcSet={`${optimizedImage(content.hero_image_url, 360, 70)} 360w, ${optimizedImage(content.hero_image_url, 640, 70)} 640w, ${optimizedImage(content.hero_image_url, 900, 70)} 900w`}
              sizes="(max-width: 768px) calc(100vw - 4rem), 50vw"
              alt="Expert technician repairing an air conditioner"
              width={900}
              height={675}
              loading="eager"
              fetchPriority="high"
              decoding="async"
              className="relative rounded-3xl shadow-elegant ring-1 ring-border w-full h-auto object-cover"
            />
          )}
        </div>
      </div>
    </section>
  );
}
